import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getIsMobile } from 'Store/Screen/selectors';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { staticContent } from 'Components/MenuMain/MenuMainContent';
import MenuMainDesktop from 'Components/MenuMain/MenuMainDesktop/MenuMainDesktop';
import MenuMainMobile from 'Components/MenuMain/MenuMainMobile/MenuMainMobile';
import { getEmptyCategoryIDs } from 'Pages/EventsPage/Redux/selectors';

interface IPropsInternal {
  isMobile: boolean;
  emptyCategoryIDs: number[];
}

type Props = IPropsInternal & RouteComponentProps<{}>;

interface IState {
  isShowingSearchForm: boolean;
  currentSearchInput: string;
}

class MenuMainContainer extends React.PureComponent<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isShowingSearchForm: false,
      currentSearchInput: '',
    }
  }

  getVisibleCategories = () =>  {
    return staticContent.categories.filter(c => c.id > 0);
  }

  getIsStartPage = () => {
    return this.props.location.pathname === '/';
  }

  hideSearchForm = () => {
    this.setState({ isShowingSearchForm: false, currentSearchInput: '' });
  }

  toggleSearchForm = () => {
    this.setState({ isShowingSearchForm: !this.state.isShowingSearchForm });
  }

  onSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ currentSearchInput: e.currentTarget.value });
  }

  onSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const searchQuery = this.state.currentSearchInput;
    this.props.history.push(`/search/${ searchQuery }`);
  }

  render() {
    const {
      homeImageUrl, 
      dropdownDesktop,
      dropdownMobile, 
    } = staticContent;

    if (this.props.isMobile) {
      return (
        <MenuMainMobile
          isStartPage={ this.getIsStartPage() }
          isShowingSearchForm={ this.state.isShowingSearchForm }
          homeImageUrl={ homeImageUrl }
          dropdownMobile={ dropdownMobile }
          onSearchIconClick={ this.toggleSearchForm }
          onSearchCloseClick={ this.hideSearchForm }
          onSearchChange={ this.onSearchChange }
          onSearchSubmit={ this.onSearchSubmit }
        />
      );
    }

    return (
      <MenuMainDesktop 
        isStartPage={ this.getIsStartPage() }
        isShowingSearchForm={ this.state.isShowingSearchForm }
        homeImageUrl={ homeImageUrl }
        dropdownDesktop={ dropdownDesktop }
        visibleCategories={ this.getVisibleCategories() }
        emptyCategoryIDs={ this.props.emptyCategoryIDs }
        onSearchIconClick={ this.toggleSearchForm }
        onSearchCloseClick={ this.hideSearchForm }
        onSearchChange={ this.onSearchChange }
        onSearchSubmit={ this.onSearchSubmit }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isMobile: getIsMobile(state),
    emptyCategoryIDs: getEmptyCategoryIDs(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(MenuMainContainer);


// WEBPACK FOOTER //
// ./src/components/MenuMain/MenuMainContainer.tsx